{
  "help": "Nápověda",
  "info": "Informace"
}
